import {styled} from '@mui/material/styles';

export const UlForTermsAndConditions = styled('ul')(() => ({
  paddingLeft: '1.5em',
  margin: 0,
  listStyleType: 'decimal',
  paddingBottom: '24px',
}));
